<script setup lang="ts">
// import blogDetailQuery from '~layers/app/graphql/blogDetail.gql'

const meta = inject('meta', ref())
const { strapiData, strapiError, getStrapiData } = useStrapiCms(meta?.value?.strapi_id, undefined, 'blogDetail', 'blogDetail')
const { $t } = useI18n()

await getStrapiData()

const pageTitle = computed(
  () => strapiData.value?.PageTitle || '',
)

const metaTitle = computed(
  () => strapiData.value?.MetaData?.MetaTitle || pageTitle.value + ' | ' + $t('meta.title'),
)

const metaDescription = computed(
  () => strapiData.value?.MetaData?.MetaDescription || $t('meta.description'),
)

const { setBreadcrumbs } = useBreadcrumbs()
setBreadcrumbs({
  label: pageTitle.value,
  parents: meta.value.parents,
})

const { pageView } = useDataLayer()
pageView('blog-detail', metaTitle.value)

useHead({
  title: metaTitle,
  meta: [
    { name: 'description', content: metaDescription },
    { name: 'robots', content: strapiData.value?.MetaData?.MetaRobots?.replace('_', ', ') },
  ],
})

const route = useRoute()
const { canonical } = useSeo()
canonical(computed(() => route.path))
</script>

<template>
  <div class="blog-detail">
    <AppBreadcrumbs v-if="$route.path !== '/'" />

    <template v-if="strapiData">
      <BlogHeader
        class="blog-detail__header"
        :strapi-data="strapiData"
      />

      <StrapiSlices
        :slices="strapiData.Slices"
      />

      <BlogAuthor
        class="blog-detail__author"
        :author="strapiData?.Author"
      />

      <BlogFooter
        class="blog-detail__footer"
        :strapi-data="strapiData"
      />

      <!--  -->
      <!--  -->
    </template>

    <DevOnly v-else-if="strapiError">
      <pre class="app__container">strapiError: {{ strapiError }}</pre>
    </DevOnly>

    <SlicesMobileStickyButton
      v-if="strapiData?.MobileStickyButton"
      :button="strapiData.MobileStickyButton"
    />
  </div>
</template>

<style>
@import url("~layers/app/pages/~blog-detail.css");
</style>
